import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: 'app-rates-info-banner',
  templateUrl: './rates-info-banner.component.html',
  styleUrls: ['./rates-info-banner.component.scss'],
})
export class RatesInfoBannerComponent implements OnInit {
  // Agreement fee percentage charged by Mable
  @Input() feePercentage?: string;

  // flag to check whether the user account type is support provider
  @Input() isCarer = false;

  // flag to check whether component is being used in the agreement
  @Input() isAgreement = false;

  @Input() isQuickpayAgreement = false;

  // Rate info banner text
  bannerText =
    'All rates are linked to 1 or more service categories. Service categories are designed to align with NDIS support categories, to streamline payment processing.';

  // Fee info text
  feeInfoText: string;

  constructor(private utilityService: UtilityService) {}

  ngOnInit(): void {
    this.setFeeInfoOnBanner(this.isQuickpayAgreement, this.isCarer);
  }

  /**
   * Sets the fee related text to be displayed within the rate info banner.
   *
   * @param isCarer - User account type
   * @param isQuickpayAgreement - show different text for QuickPay Agreement
   */
  private setFeeInfoOnBanner(isQuickpayAgreement: boolean, isCarer: boolean): void {
    if (isCarer || !this.isAgreement) {
      this.feeInfoText = '';
      return;
    }
    if (isQuickpayAgreement) {
      this.feeInfoText = `The rates below are exclusive of the 7.95% Mable fee.`;
    } else {
      this.feeInfoText = `The rates below are inclusive of the ${this.feePercentage}% Mable fee.`;
    }
  }

  /**
   * Sets the link on the banner
   *
   */
  openServiceCategoryLink(): void {
    this.utilityService.openExternalLink('https://mable.com.au/help_centre/NDIS-support-items/');
  }
}
